export default __webpack_public_path__ + "static/02-b06290df5fc945598db6db4d26c64953.jpg";